import { createAsyncThunk } from '@reduxjs/toolkit'
import { CollectionController } from 'controller/collection'
import { IEventCollectionData } from 'meta/pages/v4/eventCollection'
import { RootState } from 'store/types'

type Params = {
  collectionId: string
}

type Response = {
  data: IEventCollectionData,
  collectionId: string
}
export const getData = createAsyncThunk<Response, Params, { state: RootState }>(
  'collection/getData',
  async (params) => {
    
    const { collectionId } = params

    const data = await CollectionController.getData({ collectionId })

    return { collectionId , data }
  }
)
